var render, staticRenderFns
import script from "./SimpleCookieBannerLoader.vue?vue&type=script&lang=js&"
export * from "./SimpleCookieBannerLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75ca9a6",
  null
  
)

export default component.exports